module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-tel-green-75bf1d8a2b9040a5fa0d77fdfc9cc4f6.svg";